import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner"
;

export function useCompanyDelete(onCompanyDeleted: (id: string) => void) {
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [companyToDelete, setCompanyToDelete] = useState<string | null>(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleConfirmDeleteCompany = (id: string) => {
    setCompanyToDelete(id);
    setIsDeleteDialogOpen(true);
  };

  const handleDeleteCompany = async () => {
    if (!companyToDelete) return;
    
    try {
      setIsDeleting(true);
      
      // Simply mark the company as deleted with is_deleted flag
      const { error } = await supabase
        .from('companies')
        .update({ is_deleted: true })
        .eq('id', companyToDelete);
      
      if (error) {
        toast.error(`Failed to delete company: ${error.message}`);
        return;
      }
      
      // Update UI
      onCompanyDeleted(companyToDelete);
      toast.success("Company deleted successfully");
      setIsDeleteDialogOpen(false);
    } catch {
      toast.error('An error occurred while deleting company');
    } finally {
      setIsDeleting(false);
    }
  };

  return {
    isDeleteDialogOpen,
    setIsDeleteDialogOpen,
    companyToDelete,
    isDeleting,
    handleConfirmDeleteCompany,
    handleDeleteCompany
  };
}
